import { useSelector as userSelector, TypedUseSelectorHook, useDispatch } from 'react-redux';
import { RootState } from '../redux/store';

export const useRedux = (): { select: typeof useSelector; dispatch: typeof dispatch } => {
  const useSelector: TypedUseSelectorHook<RootState> = userSelector;
  const dispatch = useDispatch();

  return { select: useSelector, dispatch };
};
